import { Output } from "valibot";

import { BotInfoSchema } from "components/SonicBot/schemas";
import { IntegrationHandler } from "shared/integrations";
import { AppConfiguration } from "shared/types";

type Props = {
  botInfo: Output<typeof BotInfoSchema>;
  integration: IntegrationHandler;
  onIntegrationClick: (integration: IntegrationHandler) => Promise<void>;
  config: AppConfiguration;
};

function IntegrationButton(props: Props) {
  const { botInfo, integration, onIntegrationClick, config } = props;
  if (!integration.name) {
    return null;
  }
  return (
    <button
      onClick={() => {
        try {
          integration.run(onIntegrationClick, config, botInfo.id);
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
      }}
      className="hover:bg-[var(--chatBotColor)] hover:text-[var(--invertedColor)]"
      style={{
        borderRadius: "9999px",
        padding: "10px",
        width: "fit-content",
        border: `1px solid var(--chatBotColor)`,
        cursor: "pointer",
        color: "var(--chatBotColor)",
        backgroundColor: "white",
      }}
    >
      {integration.name}
    </button>
  );
}

export default IntegrationButton;
